import React from 'react';
import { NavLink } from 'react-router-dom';
import './PillLink.scss';
function PillLink({ target, children }) {
    return (React.createElement(NavLink, { className: "pill-link", to: target }, children));
}
export default PillLink;
